<template lang="pug">
#gestao-contratos-originacao-subempresa
    BaseHeader(
        :titulo='$t("mensagens.subEmpresaGestao.labels.subEmpresaGestao")',
        :exibeBotao='false'
    )

    .view-container.margen-bottom-pages
        .bloco-infor-dados(
            :class='{ "bloco-infor-dados--eudr": usuarioLogado.ambienteLogado === AmbientesEmpresas.BRASIL }'
        )
            SkeletonBlocoInformacao(:carregando='skeletonBlocoInforDados')
                BlocoInformacao(
                    :titulo='$t("mensagens.subEmpresaGestao.labels.contratos")',
                    :numero='totalContratosOriginacao.totalContratosOriginacao'
                )
                    template(slot='icone')
                        i.mdi.mdi-swap-horizontal-bold

            SkeletonBlocoInformacao(
                :carregando='skeletonBlocoInforDados',
                v-if='this.usuarioLogado.ambienteLogado === "PY"'
            )
                BlocoInformacao(
                    :titulo='$t("mensagens.subEmpresaGestao.labels.fincas")',
                    :numero='totalContratosOriginacao.totalImoveis'
                )
                    template(slot='icone')
                        i.mdi.mdi-home-variant-outline

            SkeletonBlocoInformacao(
                :carregando='skeletonBlocoInforDados',
                v-else-if='this.usuarioLogado.ambienteLogado === "AR"'
            )
                BlocoInformacao(
                    :titulo='$t("mensagens.subEmpresaGestao.labels.territorios")',
                    :numero='totalContratosOriginacao.totalImoveis'
                )
                    template(slot='icone')
                        i.mdi.mdi-home-variant-outline

            SkeletonBlocoInformacao(
                :carregando='skeletonBlocoInforDados',
                v-else
            )
                BlocoInformacao(
                    :titulo='$t("mensagens.subEmpresaGestao.labels.cars")',
                    :numero='totalContratosOriginacao.totalImoveis'
                )
                    template(slot='icone')
                        i.mdi.mdi-home-variant-outline

            SkeletonBlocoInformacao(:carregando='skeletonBlocoInforDados')
                BlocoInformacao(
                    :titulo='$t("mensagens.subEmpresaGestao.labels.volumeContratado")',
                    :numero='totalContratosOriginacao.totalVolumeContratado',
                    sigla='t'
                )
                    template(slot='icone')
                        i.mdi.mdi-chart-bar

            SkeletonBlocoInformacao(:carregando='skeletonBlocoInforDados')
                BlocoInformacao(
                    :titulo='$t("mensagens.subEmpresaGestao.labels.volumeRastreado")',
                    :numero='totalContratosOriginacao.totalVolumeEntregue',
                    sigla='t'
                )
                    template(slot='icone')
                        i.mdi.mdi-chart-bar

            SkeletonBlocoInformacao(:carregando='skeletonBlocoInforDados')
                BlocoInformacao(
                    :titulo='$t("mensagens.subEmpresaGestao.labels.volumeAndamento")',
                    :numero='totalContratosOriginacao.totalVolumeAndamento',
                    sigla='t'
                )
                    template(slot='icone')
                        i.mdi.mdi-chart-bar

            SkeletonBlocoInformacao(
                v-if='usuarioLogado.ambienteLogado === AmbientesEmpresas.BRASIL',
                :carregando='skeletonBlocoInforDados'
            )
                BlocoInformacao(
                    :titulo='$t("mensagens.subEmpresaGestao.labels.totalizadorEudr")',
                    :numero='totalContratosOriginacao?.totalEudr'
                )
                    template(slot='icone')
                        i.mdi.mdi-dots-circle

        .bloco-pesquisa-filtros
            SubEmpresaBlocoPesquisaFiltrosPY(
                v-if='this.usuarioLogado.ambienteLogado === "PY"',
                @emitFiltros='adicionarFiltrosPY'
            )

            SubEmpresaBlocoPesquisaFiltrosAR(
                v-else-if='this.usuarioLogado.ambienteLogado === "AR"',
                @emitFiltros='adicionarFiltrosAR'
            )

            BlocoPesquisaFiltros(
                v-else-if='!this.usuarioLogado.isBunge',
                @emitFiltros='adicionarFiltros'
            )
            BlocoPesquisaFiltrosOffline(
                v-else,
                @emitFiltros='adicionarFiltros'
            )
            .bloco-pesquisa-filtros__acoes
                el-button.base-button-container__btn(
                    v-if='this.usuarioLogado.ambienteLogado === "PY"',
                    type='primary',
                    :icon='"el-icon-download"',
                    @click='exportarInformesPY'
                )
                    | {{ $t('mensagens.rastreabilidadeEmpresa.contratos.gestaoContratoEmpresa.subTituloExportarRelatorio') }}

                el-button.view-modal-sucursal(
                    v-if='hasRoleFeatureRevendaSucursalesAr',
                    type='primary',
                    @click='abrirModalVincular'
                )
                    i.mdi.mdi-link-plus(style='margin-right: 5px')
                    | {{ $t('mensagens.sucursales.textoBotao') }}

                UploadRecebimentosLoteAcao(
                    v-if='usuarioLogado.ambienteLogado === AmbientesEmpresas.ARGENTINA',
                    @atualizar='buscarContratosRevenda'
                )

        .bloco-novos-contratos-preenchimento
            transition(name='alertas')
                AlertasContratos(
                    @ocultar='ocultarAlerta',
                    v-if='totalContratosOriginacao && totalContratosOriginacao.totalNovosContratos > 0 && !CheckListagemContratoErro'
                )
                    .alertas-contratos-interno
                        span {{ totalContratosOriginacao.totalNovosContratos }}
                        .bloco-interno--texto(
                            v-if='totalContratosOriginacao.totalNovosContratos === 1'
                        ) Novo contrato aguardando preenchimento.
                        .bloco-interno--texto(
                            v-if='totalContratosOriginacao.totalNovosContratos !== 1'
                        ) Novos contratos aguardando preenchimento.
                        .link(@click='filtrarAguardandoPreenchimento') {{ $t('mensagens.subEmpresaGestao.labels.apenasStatusAguardando') }}

        ModalVincularContratos(
            :show='modalVincularVisible',
            :sucursais='sucursais',
            @close='fecharModalVincular',
            @success='onVinculacaoSucesso'
        )
        .bloco-novos-contratos-tabela
            TabelaAlvorada(
                v-if='isAlvorada',
                :tabelaData='contratosTabela',
                :carregando='carregandoTabela',
                :paginacao='paginacao',
                @mudarPagina='mudarPagina',
                @ordenarTabela='ordenarTabela'
            )

            TabelaAR(
                v-else-if='this.usuarioLogado.ambienteLogado === "AR"',
                :tabelaData='contratosTabela',
                :carregando='carregandoTabela',
                :paginacao='paginacao',
                @mudarPagina='mudarPagina',
                @ordenarTabela='ordenarTabela'
            )

            TabelaPY(
                v-else-if='this.usuarioLogado.ambienteLogado === "PY"',
                :tabelaData='contratosTabela',
                :carregando='carregandoTabela',
                :paginacao='paginacao',
                @mudarPagina='mudarPagina',
                @ordenarTabela='ordenarTabela'
            )

            Tabela(
                v-else-if='!this.usuarioLogado.isBunge',
                :tabelaData='contratosTabela',
                :carregando='carregandoTabela',
                :paginacao='paginacao',
                :usuarioParaguay='this.usuarioLogado.ambienteLogado !== "PY"',
                @mudarPagina='mudarPagina',
                @ordenarTabela='ordenarTabela'
            )

            TabelaOffline(
                v-else,
                :tabelaData='contratosTabela',
                :carregando='carregandoTabela',
                :paginacao='paginacao',
                :usuarioParaguay='this.usuarioLogado.ambienteLogado !== "PY"',
                @mudarPagina='mudarPagina',
                @ordenarTabela='ordenarTabela'
            )
</template>

<script>
import BaseHeader from '@/components/BaseHeader';
import BlocoInformacao from '@/components/contratosOriginacao/SubEmpresaBlocoInformacao.vue';
import SkeletonBlocoInformacao from '@/components/contratosOriginacao/SubEmpresaBlocoInformacaoSkeleton.vue';
import Tabela from '@/components/contratosOriginacao/SubEmpresaTabelaGestao.vue';
import TabelaPY from '@/components/contratosOriginacao/SubEmpresaTabelaGestaoPY.vue';
import TabelaAR from '@/components/contratosOriginacao/SubEmpresaTabelaGestaoAR.vue';
import ModalVincularContratos from '@/components/contratosOriginacao/ModalVincularContratosSucursal.vue';
import UploadRecebimentosLoteAcao from '@/components/contratosOriginacao/UploadRecebimentosLoteAcao.vue';
import TabelaAlvorada from '@/components/contratosOriginacao/SubEmpresaTabelaGestaoAlvorada.vue';
import TabelaOffline from '@/components/contratosOriginacao/SubEmpresaTabelaGestaoOffline.vue';
import BlocoPesquisaFiltros from '@/components/contratosOriginacao/SubEmpresaBlocoPesquisaFiltros.vue';
import BlocoPesquisaFiltrosOffline from '@/components/contratosOriginacao/SubEmpresaBlocoPesquisaFiltrosOffline.vue';
import SubEmpresaBlocoPesquisaFiltrosPY from '@/components/contratosOriginacao/SubEmpresaBlocoPesquisaFiltrosPY.vue';
import SubEmpresaBlocoPesquisaFiltrosAR from '@/components/contratosOriginacao/SubEmpresaBlocoPesquisaFiltrosAR.vue';
import AlertasContratos from '@/components/contratosOriginacao/SubEmpresaAlertasContratos.vue';
import ContratoOriginacaoServiceSubEmpresa from '@/services/ContratoOriginacaoServiceSubEmpresa';
import SucursaleService from '@/services/SucursaleService';
import { mapGetters } from 'vuex';
import { AmbientesEmpresas } from '@/constants/AmbienteLogado.js';

export default {
    name: 'GestaoContratosOriginacao',
    components: {
        BaseHeader,
        BlocoInformacao,
        SkeletonBlocoInformacao,
        Tabela,
        TabelaPY,
        TabelaAlvorada,
        TabelaOffline,
        TabelaAR,
        ModalVincularContratos,
        UploadRecebimentosLoteAcao,
        BlocoPesquisaFiltros,
        BlocoPesquisaFiltrosOffline,
        SubEmpresaBlocoPesquisaFiltrosPY,
        SubEmpresaBlocoPesquisaFiltrosAR,
        AlertasContratos
    },
    data() {
        return {
            AmbientesEmpresas,
            totalContratosOriginacao: {
                totalContratosOriginacao: null,
                totalImoveis: null,
                totalVolumeContratado: null,
                totalVolumeEntregue: null,
                totalNovosContratos: null
            },
            modalVincularVisible: false,
            sucursais: [],
            contratosTabela: [],
            paginacao: {},
            params: {
                page: 0,
                size: 10,
                sort: 'dataAtualizacao',
                por: 'desc'
            },
            filtro: {
                pesquisaFiltro: '',
                idsCultura: [],
                idsSafra: [],
                codigosStatus: [],
                dataContratoInicio: '',
                dataContratoFim: '',
                idsMunicipio: [],
                idEstado: null,
                idsFornecedores: [],
                idsSubTradings: [],
                eudr: ''
            },
            skeletonBlocoInforDados: true,
            CheckListagemContratoErro: false,
            carregandoTabela: false,
            statusEmpresa: [],
            isRoleFeatureRastreabilidadeEmpresa: false
        };
    },

    computed: {
        ...mapGetters(['usuarioLogado', 'isAlvorada']),

        hasRoleFeatureRevendaSucursalesAr() {
            return this.usuarioLogado.authorities.some(
                role => role.authority === 'ROLE_FEATURE_REVENDA_SUCURSALES_AR'
            );
        }
    },
    mounted() {
        this.buscarTotalizadores();
        this.buscarContratosRevenda();

        if (this.hasRoleFeatureRevendaSucursalesAr) {
            this.getSucursales();
        }

    },
    methods: {
        async buscarTotalizadores() {
            try {
                this.skeletonBlocoInforDados = true;
                let data = null;
                if (
                    this.usuarioLogado.ambienteLogado ===
                    AmbientesEmpresas.PARAGUAY
                ) {
                    data = (
                        await ContratoOriginacaoServiceSubEmpresa.totalizadoresPY(
                            this.filtro
                        )
                    ).data;
                } else if (
                    this.usuarioLogado.ambienteLogado ===
                    AmbientesEmpresas.ARGENTINA
                ) {
                    data = (
                        await ContratoOriginacaoServiceSubEmpresa.totalizadoresAR(
                            this.filtro
                        )
                    ).data;
                } else {
                    data = (
                        await ContratoOriginacaoServiceSubEmpresa.totalizadores(
                            this.filtro
                        )
                    ).data;
                }

                this.totalContratosOriginacao = { ...data };
                this.skeletonBlocoInforDados = false;
            } catch (error) {
                this.$notify.error({
                    message: this.$t(
                        'mensagens.subEmpresaGestao.labels.naoFoiPossivelBuscar'
                    )
                });
                this.skeletonBlocoInforDados = false;
            }
        },
        getSucursales() {
            SucursaleService.listagem()
                .then(({ data }) => {
                    this.sucursais = data.sucursais;
                })
                .catch(error => {
                    this.$notify.error({
                        message: error
                    });
                });
        },
        abrirModalVincular() {
            this.modalVincularVisible = true;
        },

        fecharModalVincular() {
            this.modalVincularVisible = false;
        },

        onVinculacaoSucesso() {
            this.modalVincularVisible = false;
            this.atualizarListaContratos();
        },

        atualizarListaContratos() {
            this.buscarContratosRevenda();
            this.buscarTotalizadores();
        },

        async buscarContratosRevenda() {
            this.carregandoTabela = true;
            try {
                let data = null;
                if (
                    this.usuarioLogado.ambienteLogado ===
                    AmbientesEmpresas.PARAGUAY
                ) {
                    data = (
                        await ContratoOriginacaoServiceSubEmpresa.contratosPY(
                            this.filtro,
                            this.params
                        )
                    ).data;
                } else if (
                    this.usuarioLogado.ambienteLogado ===
                    AmbientesEmpresas.ARGENTINA
                ) {
                    data = (
                        await ContratoOriginacaoServiceSubEmpresa.contratosAR(
                            this.filtro,
                            this.params
                        )
                    ).data;
                } else {
                    data = (
                        await ContratoOriginacaoServiceSubEmpresa.contratos(
                            this.filtro,
                            this.params
                        )
                    ).data;
                }

                this.contratosTabela = data.itens;
                this.paginacao = data.paginacao;
                this.isRoleFeatureRastreabilidadeEmpresa =
                    data.roleFeatureRastreabilidadeEmpresa;
            } catch (error) {
                this.$notify.error({
                    message: this.$t(
                        'mensagens.subEmpresaGestao.labels.naoFoiPossivelBuscarDados'
                    )
                });
            }

            this.carregandoTabela = false;
        },
        mudarPagina(novaPagina) {
            this.paginacao.pagina = novaPagina;
            this.params.page = novaPagina;
            this.buscarContratosRevenda();
        },
        ordenarTabela(column) {
            this.params.sort = column.prop;
            this.params.por = column.order;
            this.buscarContratosRevenda();
        },
        adicionarFiltros(filtro) {
            this.filtro.dataContratoInicio = filtro.dataCadastroInicio;
            this.filtro.dataContratoFim = filtro.dataCadastroFim;
            this.filtro.idsCultura = filtro.culturas;
            this.filtro.idsSafra = filtro.safras;
            this.filtro.codigosStatus = filtro.status;
            this.filtro.pesquisaFiltro = filtro.pesquisa;
            this.filtro.idsMunicipio = filtro.idMunicipio;
            this.filtro.idEstado = filtro.idEstado;
            this.filtro.idsFornecedores =
                filtro.idFornecedor !== undefined ? filtro.idFornecedor : [];
            this.filtro.eudr = filtro.eudr;
            this.params.page = 0;
            this.buscarContratosRevenda();
            this.buscarTotalizadores();
        },
        adicionarFiltrosPY(filtro) {
            this.filtro.dataCadastroInicio = filtro.dataCadastroInicio;
            this.filtro.dataCadastroFim = filtro.dataCadastroFim;
            this.filtro.idsCultura = filtro.culturas;
            this.filtro.idsSafra = filtro.safras;
            this.filtro.codigosStatus = filtro.status;
            this.filtro.pesquisaFiltro = filtro.pesquisa;
            this.filtro.idLocalidadeNivelUm = filtro.idLocalidadeNivelUm;
            this.filtro.idsFornecedores =
                filtro.idFornecedor !== undefined ? filtro.idFornecedor : [];
            this.filtro.idsSubTradings =
                filtro.subTradings !== undefined ? filtro.subTradings : [];
            this.params.page = 0;
            this.buscarContratosRevenda();
            this.buscarTotalizadores();
        },
        adicionarFiltrosAR(filtro) {
            this.filtro.dataCadastroInicio = filtro.dataCadastroInicio;
            this.filtro.dataCadastroFim = filtro.dataCadastroFim;
            this.filtro.idsCultura = filtro.culturas;
            this.filtro.idsSafra = filtro.safras;
            this.filtro.codigosStatus = filtro.status;
            this.filtro.pesquisaFiltro = filtro.pesquisa;
            this.filtro.idLocalidadeNivelUm = filtro.idLocalidadeNivelUm;
            this.filtro.idsFornecedores =
                filtro.idFornecedor !== undefined ? filtro.idFornecedor : [];
            this.params.page = 0;
            this.buscarContratosRevenda();
            this.buscarTotalizadores();
        },
        filtrarAguardandoPreenchimento() {
            this.filtro.codigosStatus = ['AGUARDANDO_PREENCHIMENTO'];
            this.buscarContratosRevenda();
            this.buscarTotalizadores();
        },
        ocultarAlerta() {
            this.CheckListagemContratoErro = true;
            this.filtro.codigosStatus = [];
            this.buscarContratosRevenda();
            this.buscarTotalizadores();
        },
         async exportarInformesPY() {
            this.carregandoTabela = true;

            try {
                const ids = this.contratosTabela.map(c => c.id);

                await ContratoOriginacaoServiceSubEmpresa.exportarInformesPY(
                    ids
                );
            } catch (error) {
                this.$notify.error(
                    this.$t(
                        'mensagens.rastreabilidadeEmpresa.contratos.gestaoContratoEmpresa.erroExportarRelatorio'
                    )
                );
            }

            this.carregandoTabela = false;
        }
    }
};
</script>

<style lang="scss">
#gestao-contratos-originacao-subempresa {
    .bloco-infor-dados {
        display: grid;
        grid-template-columns: repeat(5, 1fr);
        gap: 8px;
        width: 100%;
        flex-wrap: wrap;

        &--eudr {
            display: grid;
            grid-template-columns: repeat(3, 1fr);
        }
    }

    .bloco-pesquisa-filtros {
        display: grid;
        grid-template-columns: 1fr auto;
        gap: 8px;
        align-items: start;

        &__acoes {
            display: flex;
            align-items: center;
            gap: 4px;
            height: 43px;
            margin-top: 20px;
            white-space: nowrap;
        }

        .base-button-container__btn,
        .view-modal-sucursal {
            height: 43px;
            margin-top: 0;
        }

        .view-modal-sucursal {
            height: 43px;
        }

    }

    .bloco-novos-contratos-preenchimento,
    .bloco-infor-dados,
    .bloco-pesquisa-filtros,
    .bloco-novos-contratos-tabela {
        margin-top: 20px;
    }

    .total-contratos {
        font-size: 19px;
        margin-right: 6px;
    }
}

.alertas-contratos-interno {
    display: flex;
    align-items: center;

    span {
        font-size: 22px;
        color: #3b3b3b;
        margin-right: 10px;
    }

    .link {
        color: #3fb1f2;
        margin-left: 6px;
        cursor: pointer;
        text-decoration: underline;
    }

    .link:hover {
        color: #ddac44;
    }
}

.alertas-enter-active,
.alertas-leave-active {
    transition: opacity 0.5s;
}

.alertas-enter,
.alertas-leave-to {
    opacity: 0;
}
</style>
